export default require('./TabFiles').default
